import { render } from "./ArrowLeftPopUpSvg.vue?vue&type=template&id=dc680fca"
import script from "./ArrowLeftPopUpSvg.vue?vue&type=script&lang=js"
export * from "./ArrowLeftPopUpSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__